import { useSessionStorage } from "../hooks";
import { getProfile } from "@services/krent.service";
import { validateCurrentToken, clearAuthData } from "@utils/tokenUtils";
import { isEmpty } from "@utils/helpers";
import { useEffect, useMemo, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";

type Props = {
  roleOnly?: string;
  roleAgent?: string;
};
export const PrivateRoutes = ({ roleOnly }: Props) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useSessionStorage("user", {});

  const location = useLocation();
  const auth = useMemo(() => {
    return { isAuthenticated: validateCurrentToken() };
  }, []);

  useEffect(() => {
    let abortController = new AbortController();

    if (!validateCurrentToken()) {
      setLoading(false);
      return () => {
        if (!abortController.signal.aborted) abortController.abort();
      };
    }

    if (auth.isAuthenticated && isEmpty(user)) {
      getProfile(abortController.signal)
        .then((re: any) => {
          setUser(re["data"]);
        })
        .catch((error: any) => {
          console.log("Error: ", error);
          clearAuthData();
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        });
    } else {
      setLoading(false);
    }

    return () => {
      if (!abortController.signal.aborted) abortController.abort();
    };
  }, [user, setUser, auth]);

  useEffect(() => {
    if (
      !loading &&
      !auth.isAuthenticated &&
      !location.pathname.startsWith("/sign-in")
    ) {
      localStorage.setItem(
        "postLoginRedirect",
        location.pathname + location.search
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  if (loading) {
    return <p>Loading...</p>;
  }

  return auth.isAuthenticated && !loading ? (
    !roleOnly ? (
      <Outlet />
    ) : user && user?.role === "landlord" ? (
      <Outlet />
    ) : user &&
      (user?.role === "agent" || user?.role === "property-manager") ? (
      <Outlet />
    ) : user && user?.role === "developer" ? (
      <Outlet />
    ) : user && user?.role === "user" ? (
      <Outlet />
    ) : (
      <Navigate
        to="/"
        state={{ authenticated: true, from: location }}
        replace
      />
    )
  ) : (
    <Navigate
      to="/?auth=login"
      state={{ authenticated: false, from: location }}
      replace
    />
  );
};
